export default __webpack_public_path__ + "static/media/74Uy.97b898d7.gif";